import React from "react";

const Radio = ({
  item,
  handleClickOpt,
  selected,
}) => {
  return (
    <div className="needHelpCancel">
      <span
        className="radioOuter"
        onClick={() => handleClickOpt(item)}
      >
        <input
          defaultChecked={selected && selected.id === item.id}
          type="radio"
          name="lookingFor"
          id={item.id}
        />
        <label htmlFor={item.id}>{item.text}</label>
      </span>
    </div>
  )
}

export default Radio;